import script from "./DomainRecordAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainRecordAdd.vue?vue&type=script&setup=true&lang=js"

import "./DomainRecordAdd.vue?vue&type=style&index=0&id=1649d26e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1649d26e"]])

export default __exports__